import React from 'react'
import { connect } from 'react-redux'
import { registerField, formValueSelector } from 'redux-form'
import { Tab } from 'semantic-ui-react'
import moment from 'moment'
import { translate } from 'loankeeper-common/helpers'
import { LKButton as LKBaseButton } from 'loankeeper-common/components'
//@ts-ignore
import LKModal, { actions as LKModalActions } from 'shared/LKModal'
import isEqual from 'lodash/isEqual'
import { beforeConvAddEdit, view as eventView } from '../../../store/event'

import Header from './Header'
import ConvertMainTabView from '../partials/ConvertMainTabView'
import ClientDetailsTabView from '../partials/ClientDetailsTabView'
import ClientDetailsTrigger from '../ClientAccountChoosePanel/ClientDetailsTrigger'
import { withLivedata } from '../../shared'
import AuthorizeCheckbox from '../shared/AuthorizeCheckbox'
import AuthorizeUnAuthorizeButton from '../shared/AuthorizeUnAuthorizeButton'
import AddAndOpenAgainButton from '../shared/AddAndOpenAgainButton'
import { markResubmit } from './addContainers'
import ClientValidationResults from '../../shared/Modals/ClientValidationResults'
import { translateLKMessage } from '../translate'

import {
  CHECK_DEBIT_ACCOUNT_FETCHER_NAME,
  GET_DEBIT_ACCOUNT_VIEW_FETCHER_NAME,
  GET_CREDIT_ACCOUNT_VIEW_FETCHER_NAME,
  CHECK_CREDIT_ACCOUNT_FETCHER_NAME,
  FORM_NAME,
} from './constants'
import { maskForRequiredFields } from '../constants'
import { ApiParamsData, ConvertOnAccountInCashModalProps } from './ConvertOnAccountInCash.types'

const valueSelector = formValueSelector(FORM_NAME)

//@ts-ignore
@connect(
  (state) => ({
    dob: valueSelector(state, 'DOB'),
    isClientSelected: valueSelector(state, 'clientIsChosen'),
    buyAmountA: valueSelector(state, 'buyAmountA'),
    sellAmountB: valueSelector(state, 'sellAmountB'),
    debitCCY: valueSelector(state, 'debitCCY'),
    creditCCY: valueSelector(state, 'creditCCY'),
    DocDate: valueSelector(state, 'DocDate'),
    clientID: valueSelector(state, 'clientID'),
    clientHash: valueSelector(state, 'clientHash'),
    clientType: valueSelector(state, 'clientType'),
    Name: valueSelector(state, 'Name'),
    Surname: valueSelector(state, 'Surname'),
    Name_ALT: valueSelector(state, 'Name_ALT'),
    Surname_ALT: valueSelector(state, 'Surname_ALT'),
    CellPhone: valueSelector(state, 'CellPhone'),
    DebitAccID: valueSelector(state, 'DebitAccID'),
    DebitAccHash: valueSelector(state, 'DebitAccHash'),
    CreditAccID: valueSelector(state, 'CreditAccID'),
    CreditAccHash: valueSelector(state, 'CreditAccHash'),
    IDDoc: valueSelector(state, 'IDDoc'),
    CardNumber: valueSelector(state, 'CardNumber'),
  }),
  {
    openModal: LKModalActions.open,
    openMatrixWarningConfirmation: () =>
      LKModalActions.openConfirmation('CONFIRM_MATRIX_WARNING', {
        message: translate('LKMESSAGE-CONFIRM_VALIDATION_WARNING_OVERRIDE'),
        code: 'CONFIRM_VALIDATION_WARNING_OVERRIDE',
      }),
    openError: LKModalActions.openError,
    register: registerField,
    beforeConvAddEdit,
    eventView,
  },
)
//@ts-ignore
@withLivedata('OpenDayStatus.Open_Day_Str as openDayStr')
class ConvertOnAccountInCashModal extends React.Component<ConvertOnAccountInCashModalProps> {
  delayedModal = null

  isDobModalOpen = false

  session: {
    WHLSessionID?: number
    ErrorLevel?: number
    HashSum_WHLSessionID_?: string
  } = {}

  eventParams = {}

  eventData = undefined

  state = {
    verifying: false,
    action: this.props.initialValues.action,
  }
  clientDetailView: any
  handleClose: any

  componentDidMount() {
    this.clientDetailView = undefined
    if (this.props.OperTypeID === 7) {
      // register required fields.
      // without registering, validation will not check these fields !!
      Object.keys(this.props.requiredFields).forEach((key) => {
        this.props.register(this.props.form, maskForRequiredFields[key], 'Field')
      })

      this.props.register(this.props.form, 'CreditAccNo', 'Field')
      this.props.register(this.props.form, 'DebitAccNo', 'Field')
      this.props.register(this.props.form, 'buyAmountA', 'Field')
      this.props.register(this.props.form, 'sellAmountB', 'Field')
      this.props.register(this.props.form, 'Amount', 'Field')
    }
  }

  handleOpenModal = (modal: any) => {
    this.props.openModal(modal || this.delayedModal)
  }

  handleOpenConfirmModal = (modal: any) => {
    if (this.isDobModalOpen) {
      this.delayedModal = modal
    } else {
      this.handleOpenModal(modal)
    }
  }

  handleOpenDobModal = () => {
    this.isDobModalOpen = true
    this.props.openModal({
      name: 'DobInfoModal',
      message: `${this.props.openDayStr}: ${translate('LKMESSAGE-MSG_REMIND_CLIENT_DOB')}`,
      code: 'MSG_REMIND_CLIENT_DOB',
    })
  }

  handleOpCodeChange = (selected: number) => {
    this.props.change('Comment', this.props.OpCode.find((code) => code.ID === selected).Destination)
  }

  submitAndOpenAgain = () => {
    const dob = this.checkIfTodayIsBirthday()
    this.props.change('OpenAgain', true)
    if (!this.clientIsInWatchList(dob)) {
      setTimeout(this.props.submit, 0)
    }
  }

  checkIfTodayIsBirthday = () => {
    const dob = !!(
      moment(this.props.dob, 'DD.MM.YYYY').format('M') === moment(this.props.OpenDay, 'DD.MM.YYYY').format('M') &&
      moment(this.props.dob, 'DD.MM.YYYY').format('D') === moment(this.props.OpenDay, 'DD.MM.YYYY').format('D')
    )

    if (dob && this.props.isClientSelected) {
      this.handleOpenDobModal()
    }

    return dob
  }

  clientIsInWatchList = (dob: boolean) => {
    if (this.props.clientWatched) {
      this.handleOpenConfirmModal({
        name: 'ClientWatchedConfirmation',
        message: `${translate('LKMESSAGE-CONFIRM_VALIDATION_WARNING_OVERRIDE')}`,
        code: 'CONFIRM_VALIDATION_WARNING_OVERRIDE',
        customHtml: `
          ${dob && this.props.isClientSelected ? `<p>${translate('LKMESSAGE-MSG_REMIND_CLIENT_DOB')}</p>` : ''}
          <p>${translate('LKMESSAGE-ERR_CLIENT_WATCHED')}</p>
        `,
      })

      return true
    }

    if (dob && this.props.isClientSelected) {
      this.handleOpenConfirmModal({
        name: 'ClientWatchedConfirmation',
        message: `${translate('LKMESSAGE-CONFIRM_VALIDATION_WARNING_OVERRIDE')}`,
        code: 'CONFIRM_VALIDATION_WARNING_OVERRIDE',
      })

      return true
    }

    return false
  }

  submitAndClearOpenAgainFlag = () => {
    const dob = this.checkIfTodayIsBirthday()
    this.props.change('OpenAgain', false)
    if (!this.clientIsInWatchList(dob)) {
      setTimeout(this.props.submit, 0)
    }
  }

  handleCloseClientDetails = () => {
    if (this.clientDetailView) {
      this.clientDetailView.handleClose()
    }
  }

  onVerify = () => {
    const {
      buyAmountA,
      sellAmountB,
      clientID,
      clientHash,
      Name,
      Surname,
      Name_ALT,
      Surname_ALT,
      CellPhone,
      clientType,
      DocDate,
      debitCCY,
      creditCCY,
      isClientSelected,
      clientDetails,
      DebitAccID,
      DebitAccHash,
      CreditAccID,
      CreditAccHash,
      IDDoc,
      OperTypeID,
      CardNumber,
    } = this.props

    const apiParams: ApiParamsData = {
      SP_ACT: this.state.action === 'add' ? 0 : 1,
      AMLOperTypeID: 60,
      OperTypeID,
      Amount: buyAmountA,
      AmountB: sellAmountB,
      CCY: debitCCY,
      CCYB: creditCCY,
      OperDate: DocDate,
      ClientType: clientType || (clientDetails && clientDetails.ClientType),
      DebitAccID,
      HashSum_DebitAccID_: DebitAccHash,
      CreditAccID,
      HashSum_CreditAccID_: CreditAccHash,
      IDDocID: IDDoc && IDDoc.ID,
      HashSum_IDDocID_: IDDoc && IDDoc.HashSum_IDDocID_,
      PersonalNo: CardNumber,
    }

    if (isClientSelected) {
      apiParams.ClientID = clientID
      apiParams.HashSum_ClientID_ = clientHash
    } else {
      apiParams.Name = Name
      apiParams.Surname = Surname
      apiParams.Name_ALT = Name_ALT
      apiParams.Surname_ALT = Surname_ALT
      apiParams.CellPhone = CellPhone
    }

    if (this.session.WHLSessionID && isEqual(this.eventParams, apiParams)) {
      this.props.openModal({
        name: 'ClientValidationResults',
        Data: this.eventData,
        ErrorLevel: this.session.ErrorLevel,
      })
      return
    }

    if (
      OperTypeID === 7 &&
      //@ts-ignore
      ((clientDetails && clientDetails.ClientType === 0) || clientType === 0 || (!clientDetails && !clientType))
    ) {
      apiParams.ClientType = 1
    }

    this.setState({ verifying: true })

    this.props
      .beforeConvAddEdit(apiParams)
      .then((result) => {
        if (!beforeConvAddEdit.fulfilled.match(result)) {
          throw result.payload
        }

        const { ErrorLevel, WHLSessionID, HashSum_WHLSessionID_ } = result.payload

        this.session = { WHLSessionID, HashSum_WHLSessionID_, ErrorLevel }
        this.eventParams = apiParams

        return this.props.eventView({ WHLSessionID, HashSum_WHLSessionID_ }).then((eventResult) => {
          if (!eventView.fulfilled.match(eventResult)) {
            throw eventResult.payload
          }

          const Data = eventResult.payload

          this.eventData = Data

          this.props.openModal({ name: 'ClientValidationResults', Data, ErrorLevel })
        })
      })
      .catch((e) => {
        this.props.openError(translateLKMessage((e.Error && (e.Error.Message || e.Error.Text)) || 'HINT_ERR_TITLE'))
      })
      .finally(() => {
        this.setState({ verifying: false })
      })
  }

  render() {
    const {
      name,
      form,
      OpCode = [],
      CCY,
      change,
      submitting,
      CCYOfficalRates,
      CCYCommercialRates,
      // editting,
      inCash,
      requiredFields,
      clientSelects,
      OpenDay,
      params = {},
      MoneyTransferSystem,
      clearFields,
      OperTypeID,
      CashAccounts,
      onAuthorize,
      clientDetails,
      initialValues,
      permissions,
      details,
    } = this.props

    const { verifying } = this.state

    const panes = [
      {
        menuItem: translate('frm_acc_conv_add-tb_1'),
        render: () => (
          <ConvertMainTabView
            convert
            inCash={inCash}
            ID={params.ID}
            OID={params.OID}
            OIDHash={params.OIDHash}
            hash={params.hash}
            OperTypeID={OperTypeID}
            //@ts-ignore
            OpCode={OpCode}
            CCY={CCY}
            CCYOfficalRates={CCYOfficalRates || []}
            CCYCommercialRates={CCYCommercialRates || []}
            change={change}
            form={form}
            CashAccounts={CashAccounts}
            checkDebitAccountFetcherName={CHECK_DEBIT_ACCOUNT_FETCHER_NAME}
            getDebitAccountViewFetcherName={GET_DEBIT_ACCOUNT_VIEW_FETCHER_NAME}
            checkCreditAccountFetcherName={CHECK_CREDIT_ACCOUNT_FETCHER_NAME}
            getCreditAccountViewFetcherName={GET_CREDIT_ACCOUNT_VIEW_FETCHER_NAME}
            authorizing={params.authorizing}
          />
        ),
      },
    ]

    if (inCash) {
      panes.push({
        menuItem: translate('frm_acc_conv_add-tb_2'),
        render: () => (
          //@ts-ignore
          <ClientDetailsTabView
            onRef={(ref) => {
              this.clientDetailView = ref
            }}
            change={change}
            form={form}
            requiredFields={requiredFields}
            clientSelects={clientSelects}
            OpenDay={OpenDay}
            disableInputs={params.authorizing}
            MoneyTransferSystem={MoneyTransferSystem}
            clearFields={clearFields}
            initialValues={initialValues}
            permissions={permissions}
            detailsTabData={clientDetails}
          />
        ),
      })
    }

    // TODO: investigate if DobConfirmationModal is needed
    return (
      <LKModal
        name={name}
        icon={OperTypeID === 6 ? 'entries_conv' : 'entries_convcash'}
        heading={`${translate('frm_acc_conv_add-frm_acc_conv_add')}${details ? `: OID -  ${details.OID}` : ''}`}
        size="medium"
        footer={
          <LKModal.Footer
            actions={
              params.authorizing ? (
                <AuthorizeUnAuthorizeButton
                  style={{ marginLeft: 0 }}
                  data={{ ...details, ID: details.EntryID1 }}
                  onAuthorize={onAuthorize}
                  name={name}
                  action={params.action}
                  details={{
                    OperTypeID: details.OperTypeID,
                    OID: details.OID,
                    HashSum_EntryID_: details.HashSum_EntryID_,
                    HashSum_OID_: details.HashSum_OID_,
                    EntryID: params.ID,
                  }}
                />
              ) : (
                <AuthorizeCheckbox FormName={form} />
              )
            }
            sideActions={
              <>
                <ClientDetailsTrigger
                  name="ClientDetailForNoLinkFile"
                  FormName={form}
                  noTrigger
                  onClose={this.handleCloseClientDetails}
                />

                {this.props.OperTypeID === 7 && (
                  <LKBaseButton alias="amlCheckmark" loading={verifying} disabled={verifying} onClick={this.onVerify} />
                )}

                {!params.authorizing && (
                  <>
                    <AddAndOpenAgainButton
                      FormName={form}
                      submitting={submitting}
                      onClick={this.submitAndOpenAgain}
                      onClose={this.handleClose}
                    />
                    <LKBaseButton.Okay
                      //@ts-ignore
                      style={{ width: 85, marginRight: 0 }}
                      disabled={submitting}
                      loading={submitting}
                      onClick={this.submitAndClearOpenAgainFlag}
                    />
                  </>
                )}

                {params.authorizing && (
                  <LKModal.CancelButton
                    disabled={submitting}
                    loading={submitting}
                    text={translate('frm_acc_entry_add-cmd_close')}
                  />
                )}
              </>
            }
          />
        }
        fullBody
      >
        <ClientValidationResults
          name="ClientValidationResultsConfirm"
          onClose={this.props.openMatrixWarningConfirmation}
        />

        <LKModal.Confirmation
          name="CONFIRM_MATRIX_WARNING"
          onConfirm={() => {
            markResubmit()
            this.submitAndClearOpenAgainFlag()
          }}
        />
        <LKModal.Confirmation name="ClientWatchedConfirmation" onConfirm={() => this.props.submit()} />
        <LKModal.Confirmation name="DobConfirmationModal" onConfirm={() => this.props.submit()} />
        <LKModal.Dob name="DobInfoModal" onConfirm={this.handleOpenModal} />
        <Header
          heading={translate(
            OperTypeID === 6 ? 'frm_acc_conv_add-lbl_ot_conv_acc' : 'frm_acc_conv_add-lbl_ot_conv_cash',
          )}
          OperTypeID={OperTypeID}
          form={form}
          name={name}
        />
        <Tab panes={panes} />
      </LKModal>
    )
  }
}

//@ts-ignore
ConvertOnAccountInCashModal.defaultProps = {
  requiredFields: {},
}

export default ConvertOnAccountInCashModal
